"use client";

import { createContext, useContext, useState } from "react";
import type { Market } from "./market";

interface CareersMarketContextType {
  market: Market | null;
  setMarket: React.Dispatch<React.SetStateAction<Market | null>>;
}

const CareersMarketContext = createContext<CareersMarketContextType | null>(null);

export function CareersMarketProvider({ children }: { children: React.ReactNode }) {
  const [market, setMarket] = useState<Market | null>(null);

  return (
    <CareersMarketContext.Provider value={{ market, setMarket }}>
      {children}
    </CareersMarketContext.Provider>
  );
}

// Null outside a provider — consumers fall back to local state.
export function useCareersMarket() {
  return useContext(CareersMarketContext);
}
